"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = void 0;
var Main_1 = require("./main/Main");
Object.defineProperty(exports, "Main", { enumerable: true, get: function () { return Main_1.Main; } });
